import { Guardian } from '@xaamin/guardian';

Guardian.define('receptor.crear', (user) => {
  return user.can(['receptor.crear']) && user.can('receptor.listar');
});

Guardian.define('receptor.listar', (user) => {
  return user.can('receptor.listar');
});

Guardian.define('receptor.info', (user) => {
  return user.can('receptor.info');
});

Guardian.define('receptor.editar', (user) => {
  return user.can('receptor.editar');
});

Guardian.define('receptor.bloquear', (user) => {
  return user.can('receptor.bloquear');
});

Guardian.define('receptor.descargar', (user) => {
  return user.can('receptor.descargar');
});

Guardian.define('receptor.crear.excel', (user) => {
  return user.can('receptor.crear.excel');
});

Guardian.define('receptor.listar.archivos', (user) => {
  return user.can('receptor.listar.archivos');
});

Guardian.define('receptor.listar.excel', (user) => {
  return user.can('receptor.listar.excel');
});

Guardian.define('receptor.info.receptores.excel', (user) => {
  return user.can('receptor.info.receptores.excel');
});